"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyVueMarketStrategies = applyVueMarketStrategies;
const utils_1 = require("../../utils");
const baseVueMarketStrategy_1 = require("./baseVueMarketStrategy");
const enVKVStrategy_1 = require("./enVKVStrategy");
const strategies = [
    {
        name: "base",
        condition: (_) => true,
        strategy: baseVueMarketStrategy_1.baseVueMarketStrategy,
    },
    {
        name: "enVKV",
        condition: (locale) => (0, utils_1.isGermanMarket)(locale),
        strategy: enVKVStrategy_1.enVKVStrategy,
    },
];
// based on the market we apply different strategies. The base strategy will always be applied.
// For the german market, we apply the enVKV strategy additionally.
function applyVueMarketStrategies(vue, locale, i18nlanguage) {
    const result = strategies.reduce((prevVue, s) => {
        if (!s.condition(locale))
            return prevVue;
        return s.strategy({ vue: prevVue, locale, i18nlanguage }, prevVue);
    }, vue);
    return result;
}
